import { render, staticRenderFns } from "./EvaluacionesDesempenioAcademicoTabContent.vue?vue&type=template&id=58ecb526"
import script from "./EvaluacionesDesempenioAcademicoTabContent.vue?vue&type=script&lang=js"
export * from "./EvaluacionesDesempenioAcademicoTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports